/**
 * Venue names are typed by hand and some carry stray spaces
 * ("A Business With No Name "), which then show in copy. Tidy them where
 * venues enter the store so every screen and comparison sees the same name.
 */

/** @param {unknown} name */
export const tidyVenueName = name =>
  typeof name === 'string' ? name.replace(/\s+/g, ' ').trim() : name

/** Same venue object with a tidy `title` (input is never mutated). */
export const withTidyVenueTitle = venue =>
  venue && typeof venue === 'object' && typeof venue.title === 'string'
    ? { ...venue, title: tidyVenueName(venue.title) }
    : venue

/** Account-shaped object with tidy venue titles. */
export const withTidyAccountVenues = account =>
  account && Array.isArray(account.venues)
    ? { ...account, venues: account.venues.map(withTidyVenueTitle) }
    : account

/** Display tidy for names that embed a venue ("… (Shared with A Venue )"). */
export const tidyDisplayTitle = title =>
  typeof title === 'string'
    ? title.replace(/\s+/g, ' ').replace(/\s+\)/g, ')').trim()
    : title
